export default "__VITE_ASSET__C1Ie_E3d__"